import React from 'react';

const iconSvgs: Record<string, (size: number) => React.ReactElement> = {
    shield: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L8 9V17C8 25 20 34 20 34C20 34 32 25 32 17V9L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M14 19L18 23L26 14'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),
    heart: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 12C18 6 10 6 8 12C6 18 10 24 20 34C30 24 34 18 32 12C30 6 22 6 20 12Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    'hand-heart': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 14C18 10 14 10 12 12C10 14 10 18 14 22L20 28L26 22C30 18 30 14 28 12C26 10 22 10 20 14Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M10 32H30'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    balance: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4V32M14 32H26'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={
                    'M8 12L4 20C4 22 6 24 10 24C14 24 16 22 16 20L12 12M28 12L24 20C24 22 26 24 30 24C34 24 36 22 36 20L32 12'
                }
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />

            <path
                d={'M8 12H32'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    handshake: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 16L10 10L16 14L20 12L24 14L30 10L36 16'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />

            <path
                d={'M4 24L16 28L24 28L36 24'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />

            <path
                d={'M10 10V24M30 10V24'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    anchor: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'10'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 14V34M12 22H8C8 30 12 34 20 34C28 34 32 30 32 22H28'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M14 14H26'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    compass: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <polygon
                points={'20,8 24,20 20,32 16,20'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    lighthouse: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M14 36H26L24 18H16L14 36Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M16 18L18 10H22L24 18'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'6'}
                r={'2'}
                fill={'white'}
            />

            <path
                d={'M8 8L14 10M32 8L26 10'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    star: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L24 16H36L26 23L30 35L20 28L10 35L14 23L4 16H16L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),
    diamond: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M12 8H28L36 16L20 36L4 16L12 8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M12 8L20 16M28 8L20 16M4 16H36'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    crown: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 28V14L14 20L20 8L26 20L34 14V28H6Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M6 32H34'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    trophy: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M12 8H28V16C28 22 24 26 20 26C16 26 12 22 12 16V8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M12 12H8C8 16 10 18 12 18M28 12H32C32 16 30 18 28 18'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M20 26V30M14 34H26M14 30H26'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    medal: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'26'}
                r={'10'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M14 4L20 16L26 4'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M20 22L22 26L20 30L18 26L20 22Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    ribbon: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'14'}
                r={'8'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M14 20L8 36L16 30L20 36L24 30L32 36L26 20'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),
    laurel: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 32C8 24 12 16 20 12C12 16 8 8 8 8'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M32 32C32 24 28 16 20 12C28 16 32 8 32 8'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <circle
                cx={'20'}
                cy={'12'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    badge: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L24 8H32V16L36 20L32 24V32H24L20 36L16 32H8V24L4 20L8 16V8H16L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'20'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    lightbulb: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 4C14 4 10 9 10 14C10 19 14 22 16 26V30H24V26C26 22 30 19 30 14C30 9 26 4 20 4Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M16 34H24M18 38H22'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    rocket: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 5C20 5 28 8 28 15V24L20 35L12 24V15C12 8 20 5 20 5Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'16'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    lightning: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M22 2L8 22H20L18 38L32 18H20L22 2Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),
    growth: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 32L14 24L20 28L28 18L34 8'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />

            <path
                d={'M26 8H34V16'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),
    'arrow-up': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 34V6M20 6L10 16M20 6L30 16'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),
    mountain: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 32L16 10L24 22L28 16L36 32H4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),
    sunrise: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 28H36M8 28C8 20 14 14 20 14C26 14 32 20 32 28'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M20 4V8M8 16L11 19M32 16L29 19M4 28H36'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    sparkle: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L22 16L34 18L22 20L20 32L18 20L6 18L18 16L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M32 6L33 10L37 11L33 12L32 16L31 12L27 11L31 10L32 6Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),
    users: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'14'}
                cy={'14'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'26'}
                cy={'14'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M4 34C4 28 8 24 14 24C16 24 18 25 20 26C22 25 24 24 26 24C32 24 36 28 36 34'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    'circle-users': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'16'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M12 28C12 24 16 22 20 22C24 22 28 24 28 28'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    'hands-together': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 20C8 16 12 12 16 12C18 12 20 14 20 16C20 14 22 12 24 12C28 12 32 16 32 20'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M8 20V28C8 30 10 32 12 32H28C30 32 32 30 32 28V20'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    bridge: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 28H36M8 28V20C8 14 14 10 20 10C26 10 32 14 32 20V28'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M8 20H32'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    chain: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <ellipse
                cx={'14'}
                cy={'16'}
                rx={'6'}
                ry={'8'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <ellipse
                cx={'26'}
                cy={'24'}
                rx={'6'}
                ry={'8'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M18 18L22 22'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    puzzle: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 8H18V12C18 14 16 16 14 16C16 16 18 18 18 20V24H8V8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M22 8H32V24H22V20C22 18 24 16 26 16C24 16 22 14 22 12V8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M8 28H32V32H8V28Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    network: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'8'}
                cy={'10'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'32'}
                cy={'10'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'8'}
                cy={'30'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'32'}
                cy={'30'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M17 17L11 13M23 17L29 13M17 23L11 27M23 23L29 27'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    globe: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <ellipse
                cx={'20'}
                cy={'20'}
                rx={'6'}
                ry={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M6 20H34'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    target: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'20'}
                r={'7'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'20'}
                r={'11'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 2V8M20 32V38M2 20H8M32 20H38'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    'user-star': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'12'}
                r={'8'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M8 36C8 28 14 24 20 24C26 24 32 28 32 36'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M32 8L33 11H36L34 13L35 16L32 14L29 16L30 13L28 11H31L32 8Z'}
                fill={'white'}
            />
        </svg>
    ),
    smile: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'14'}
                cy={'16'}
                r={'2'}
                fill={'white'}
            />

            <circle
                cx={'26'}
                cy={'16'}
                r={'2'}
                fill={'white'}
            />

            <path
                d={'M12 24C14 28 26 28 28 24'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    'thumbs-up': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M12 36H8V18H12V36ZM16 18L20 6L26 8V18H34V28L30 36H16V18Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    'service-bell': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 30H34M10 30C10 22 14 16 20 16C26 16 30 22 30 30'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M18 12H22V16H18V12ZM20 8V12'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    gift: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'16'}
                width={'28'}
                height={'18'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M6 22H34M20 16V34'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M20 16C20 12 16 8 12 10C8 12 12 16 20 16C28 16 32 12 28 10C24 8 20 12 20 16Z'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    'heart-handshake': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 12C18 6 10 6 8 12C6 18 10 24 20 34C30 24 34 18 32 12C30 6 22 6 20 12Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M12 20H16L20 16L24 20H28'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    ear: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M28 12C28 6 24 4 20 4C12 4 8 10 8 18C8 26 12 32 18 36'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={
                    'M28 12C28 16 24 20 20 20C16 20 14 18 14 16C14 14 16 12 18 12C20 12 22 14 22 16C22 18 20 20 18 22'
                }
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    brain: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 8C14 8 10 12 10 18C10 22 12 26 16 28V32H24V28C28 26 30 22 30 18C30 12 26 8 20 8Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M14 18C14 14 17 12 20 12M26 18C26 14 23 12 20 12'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    book: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 8C10 6 16 6 20 10C24 6 30 6 34 8V32C30 30 24 30 20 34C16 30 10 30 6 32V8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 10V34'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    graduation: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 16L20 8L36 16L20 24L4 16Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M10 20V28C10 30 14 34 20 34C26 34 30 30 30 28V20'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M36 16V28'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    eye: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 20C4 20 10 10 20 10C30 10 36 20 36 20C36 20 30 30 20 30C10 30 4 20 4 20Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'20'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    microscope: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'18'}
                cy={'12'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M18 18V28M12 36H28M18 28C14 28 10 32 10 36'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M24 16L28 12'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    lamp: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M12 24L8 36H32L28 24M12 24H28M12 24C8 20 8 12 12 8C18 2 30 6 28 16C28 20 28 24 28 24'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 12V8M14 14L10 10M26 14L30 10'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    scroll: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M12 4C8 4 6 6 6 8C6 10 8 12 12 12H28C32 12 34 10 34 8C34 6 32 4 28 4H12Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M6 8V32C6 34 8 36 12 36H28C32 36 34 34 34 32V8'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M12 20H28M12 26H22'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    owl: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4C12 4 6 10 6 18C6 26 12 36 20 36C28 36 34 26 34 18C34 10 28 4 20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'14'}
                cy={'16'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'26'}
                cy={'16'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'14'}
                cy={'16'}
                r={'2'}
                fill={'white'}
            />

            <circle
                cx={'26'}
                cy={'16'}
                r={'2'}
                fill={'white'}
            />

            <path
                d={'M20 22V26M18 26L20 28L22 26'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M8 8L12 12M32 8L28 12'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    tree: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L8 18H14L6 28H34L26 18H32L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M20 28V36'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    leaf: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 32C8 18 18 8 32 8C32 22 22 32 8 32Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M8 32C14 26 20 20 32 8'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    earth: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M8 14H14C16 14 18 16 18 18V22C18 24 20 26 22 26H28'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M26 10V16C26 18 28 20 30 20'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    sun: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'8'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={
                    'M20 4V8M20 32V36M4 20H8M32 20H36M8.5 8.5L11 11M29 29L31.5 31.5M31.5 8.5L29 11M11 29L8.5 31.5'
                }
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    water: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L8 22C8 30 14 36 20 36C26 36 32 30 32 22L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    flower: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'16'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'12'}
                cy={'20'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'28'}
                cy={'20'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'14'}
                cy={'12'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'26'}
                cy={'12'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 22V36'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    rainbow: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 28C4 18 12 10 20 10C28 10 36 18 36 28'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M10 28C10 22 14 16 20 16C26 16 30 22 30 28'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M16 28C16 24 18 22 20 22C22 22 24 24 24 28'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    recycle: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L26 12L20 8L14 12L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M8 28L4 20L10 22L12 16L8 28Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M32 28L36 20L30 22L28 16L32 28Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 8L8 28H32L20 8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    fire: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4C14 12 8 16 8 24C8 30 14 36 20 36C26 36 32 30 32 24C32 16 26 12 20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={
                    'M20 20C18 24 16 26 16 28C16 31 18 34 20 34C22 34 24 31 24 28C24 26 22 24 20 20Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    lion: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'10'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
                strokeDasharray={'4 2'}
            />

            <circle
                cx={'16'}
                cy={'18'}
                r={'2'}
                fill={'white'}
            />

            <circle
                cx={'24'}
                cy={'18'}
                r={'2'}
                fill={'white'}
            />

            <path
                d={'M18 24C18 24 20 26 22 24'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    fist: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M12 20V12C12 10 14 8 16 8C18 8 20 10 20 12V8C20 6 22 4 24 4C26 4 28 6 28 8V20'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={
                    'M12 20C10 20 8 22 8 24V28C8 32 12 36 16 36H24C28 36 32 32 32 28V20C32 18 30 16 28 16'
                }
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    phoenix: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 36C16 32 12 24 12 16C12 8 16 4 20 4C24 4 28 8 28 16C28 24 24 32 20 36Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M12 16C8 18 4 22 4 28M28 16C32 18 36 22 36 28'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M16 12L20 8L24 12'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    wings: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 20C12 20 4 14 4 8C8 10 14 12 20 12C26 12 32 10 36 8C36 14 28 20 20 20Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 20V32M16 32H24'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    sword: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4V24M14 24H26M20 24L16 28L20 36L24 28L20 24Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M16 8L24 8'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    fortress: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 36V18L4 18V12H10V8H14V12H26V8H30V12H36V18L32 18V36H8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M16 36V26H24V36'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    eagle: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 8C14 8 8 14 8 20C8 24 12 28 20 28C28 28 32 24 32 20C32 14 26 8 20 8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M4 20C4 20 8 16 12 16M36 20C36 20 32 16 28 16'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M18 16L20 18L22 16M20 20V24'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    palette: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 4C10 4 4 12 4 20C4 28 10 36 20 36C24 36 26 34 26 32C26 30 24 28 26 26C28 24 32 24 34 22C36 18 32 4 20 4Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'12'}
                cy={'16'}
                r={'2'}
                fill={'white'}
            />

            <circle
                cx={'18'}
                cy={'10'}
                r={'2'}
                fill={'white'}
            />

            <circle
                cx={'26'}
                cy={'12'}
                r={'2'}
                fill={'white'}
            />

            <circle
                cx={'12'}
                cy={'24'}
                r={'2'}
                fill={'white'}
            />
        </svg>
    ),
    music: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M14 32C14 34 12 36 10 36C8 36 6 34 6 32C6 30 8 28 10 28C12 28 14 30 14 32ZM14 32V10L32 6V28M32 28C32 30 30 32 28 32C26 32 24 30 24 28C24 26 26 24 28 24C30 24 32 26 32 28Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    pen: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 32L6 36L10 34L32 12L28 8L8 32Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M28 8L32 4L36 8L32 12L28 8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    camera: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'12'}
                width={'32'}
                height={'22'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'22'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M14 12L16 8H24L26 12'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    theater: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'14'}
                cy={'18'}
                r={'10'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'26'}
                cy={'18'}
                r={'10'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M10 16V14M18 16V14'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M22 16V14M30 16V14'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M10 22C12 24 16 24 18 22'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M22 22C24 20 28 20 30 22'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    brush: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M28 4L12 20C10 22 10 26 12 28C14 30 18 30 20 28L36 12L28 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M12 28C10 30 6 32 4 36C8 34 10 30 12 28Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    origami: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 20L20 4L36 20L20 36L4 20Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M4 20L20 20L20 36M20 20L36 20'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    'diamond-alt': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L36 20L20 36L4 20L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M10 20L20 10L30 20L20 30L10 20Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    message: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 8H34V28H18L10 34V28H6V8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M12 16H28M12 22H22'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    megaphone: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 16V24H12L24 32V8L12 16H8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M28 14C30 16 30 24 28 26'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M32 10C36 14 36 26 32 30'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    'open-book': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 8H18C18 8 20 6 20 8V32C18 30 16 30 14 30H4V8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M36 8H22C22 8 20 6 20 8V32C22 30 24 30 26 30H36V8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    mirror: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <ellipse
                cx={'20'}
                cy={'18'}
                rx={'12'}
                ry={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M16 32H24L22 36H18L16 32Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    speech: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 8H32C34 8 36 10 36 12V24C36 26 34 28 32 28H14L8 34V28V12C8 10 8 8 8 8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M14 16H26M14 22H22'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    window: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'8'}
                width={'28'}
                height={'24'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M6 20H34M20 8V32'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    prism: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L36 32H4L20 4Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 4L20 32'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    lantern: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M14 8H26L28 14H12L14 8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M12 14V30C12 32 14 34 16 34H24C26 34 28 32 28 30V14'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M20 4V8M20 18V26'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    clock: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 10V20L26 26'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    infinity: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 20C20 20 24 14 28 14C32 14 36 18 36 20C36 22 32 26 28 26C24 26 20 20 20 20ZM20 20C20 20 16 14 12 14C8 14 4 18 4 20C4 22 8 26 12 26C16 26 20 20 20 20Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    hourglass: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M10 4H30V10C30 16 24 20 20 20C16 20 10 16 10 10V4ZM10 36H30V30C30 24 24 20 20 20C16 20 10 24 10 30V36Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M8 4H32M8 36H32'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    calendar: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'8'}
                width={'28'}
                height={'26'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M6 16H34M12 4V12M28 4V12'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M12 22H14M18 22H20M24 22H26M12 28H14M18 28H20'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    refresh: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 20C6 12 12 6 20 6C26 6 32 10 34 16M34 20C34 28 28 34 20 34C14 34 8 30 6 24'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M34 8V16H26M6 32V24H14'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),
    moon: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M30 20C30 28 24 34 16 34C12 34 9 32 7 30C10 32 14 33 18 31C24 28 26 22 24 16C23 12 20 9 16 8C20 6 26 8 29 14C30 16 30 18 30 20Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    seasons: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 6V20M6 20H20'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <circle
                cx={'14'}
                cy={'14'}
                r={'2'}
                fill={'white'}
            />

            <path
                d={'M24 14L28 10'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M26 26L28 28'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    milestone: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M10 4V36'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M10 10H28L24 16L28 22H10'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),
    lock: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'8'}
                y={'18'}
                width={'24'}
                height={'18'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M14 18V12C14 8 16 4 20 4C24 4 26 8 26 12V18'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <circle
                cx={'20'}
                cy={'28'}
                r={'2'}
                fill={'white'}
            />
        </svg>
    ),
    key: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'14'}
                cy={'14'}
                r={'8'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 20L34 34M28 28L32 24M32 32L36 28'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    umbrella: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 6C10 6 4 14 4 20H36C36 14 30 6 20 6Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 6V30C20 32 18 34 16 34C14 34 12 32 12 30'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    home: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 20L20 8L34 20V34H24V26H16V34H6V20Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    'first-aid': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'10'}
                width={'28'}
                height={'20'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M20 14V26M14 20H26'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    embrace: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'12'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M10 36C10 28 14 22 20 22C26 22 30 28 30 36'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M8 24C4 26 4 32 8 34M32 24C36 26 36 32 32 34'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    nest: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 28C8 22 14 18 20 18C26 18 32 22 32 28'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M4 32C4 24 12 16 20 16C28 16 36 24 36 32'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <circle
                cx={'16'}
                cy={'26'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'24'}
                cy={'26'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    guardian: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'12'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M10 36V24C10 22 12 20 14 20H26C28 20 30 22 30 24V36'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M20 20V28L16 32V36M20 28L24 32V36'}
                stroke={'white'}
                strokeWidth={'2'}
            />
        </svg>
    ),
    fingerprint: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4C12 4 6 10 6 18C6 24 8 30 12 34'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M20 4C28 4 34 10 34 18C34 24 32 30 28 34'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M20 10C14 10 10 14 10 20C10 24 12 28 16 30'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M20 10C26 10 30 14 30 20C30 24 28 28 24 30'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M20 16C18 16 16 18 16 20C16 22 17 24 20 26'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    flag: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M10 4V36'}
                stroke={'white'}
                strokeWidth={'2'}
            />

            <path
                d={'M10 8H30L24 16L30 24H10V8Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    signature: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 28C8 24 12 20 16 24C20 28 24 16 28 20C32 24 36 20 36 20'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M4 34H36'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),
    dna: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M12 4C12 12 20 16 28 16C28 24 20 28 12 28C12 36 20 40 28 40'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M28 4C28 12 20 16 12 16C12 24 20 28 28 28C28 36 20 40 12 40'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />
        </svg>
    ),
    'heart-pulse': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 12C18 6 10 6 8 12C6 18 10 24 20 34C30 24 34 18 32 12C30 6 22 6 20 12Z'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <path
                d={'M10 20H16L18 16L22 24L24 20H30'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),
    atom: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <ellipse
                cx={'20'}
                cy={'20'}
                rx={'14'}
                ry={'6'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <ellipse
                cx={'20'}
                cy={'20'}
                rx={'14'}
                ry={'6'}
                transform={'rotate(60 20 20)'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <ellipse
                cx={'20'}
                cy={'20'}
                rx={'14'}
                ry={'6'}
                transform={'rotate(120 20 20)'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'20'}
                r={'3'}
                fill={'white'}
            />
        </svg>
    ),
    core: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'20'}
                r={'8'}
                stroke={'white'}
                strokeWidth={'2'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'20'}
                r={'3'}
                fill={'white'}
            />
        </svg>
    ),
    roots: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 4V16M20 16C16 20 12 28 8 36M20 16C20 24 20 32 20 36M20 16C24 20 28 28 32 36'
                }
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />

            <path
                d={'M14 8C14 8 16 10 20 10C24 10 26 8 26 8'}
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    // Strategic pillar icons (prototype catalogue)
    'chart-pie': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M20 20V6M20 20L30 28'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    'chart-bar': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 34V18M16 34V10M24 34V22M32 34V14'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    cloud: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M10 28C6 28 4 24 4 20C4 16 6 12 10 12C10 8 14 4 20 4C26 4 30 8 30 12C34 12 36 16 36 20C36 24 34 28 30 28H10Z'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    server: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'6'}
                width={'28'}
                height={'10'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <rect
                x={'6'}
                y={'24'}
                width={'28'}
                height={'10'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'12'}
                cy={'11'}
                r={'1'}
                fill={'white'}
            />

            <circle
                cx={'12'}
                cy={'29'}
                r={'1'}
                fill={'white'}
            />
        </svg>
    ),

    code: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M14 12L6 20L14 28M26 12L34 20L26 28M22 8L18 32'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    terminal: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'8'}
                width={'32'}
                height={'24'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M10 16L16 20L10 24M20 24H28'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    gear: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M20 4V10M20 30V36M36 20H30M10 20H4M31 9L27 13M13 27L9 31M31 31L27 27M13 13L9 9'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    wrench: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M6 34L18 22C16 18 18 12 22 10L26 14L24 16L28 20L30 18L34 22C32 26 26 28 22 26L10 38C8 40 4 38 6 34Z'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    hammer: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 24L16 16L24 24L16 32L8 24Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M16 16L22 10H32V20L26 26L24 24'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    magnet: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M10 6V18C10 24 14 28 20 28C26 28 30 24 30 18V6M10 6H14M26 6H30M10 12H14M26 12H30'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    battery: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'12'}
                width={'28'}
                height={'16'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M32 18H36V22H32M8 16H24'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    wifi: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M4 14C8 10 14 8 20 8C26 8 32 10 36 14M8 20C10 18 14 16 20 16C26 16 30 18 32 20M14 26C16 24 18 24 20 24C22 24 24 24 26 26'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />

            <circle
                cx={'20'}
                cy={'32'}
                r={'2'}
                fill={'white'}
            />
        </svg>
    ),

    airplane: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 6L24 14L36 16L26 22L28 34L20 28L12 34L14 22L4 16L16 14L20 6Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    building: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'8'}
                y={'6'}
                width={'24'}
                height={'28'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 12H18M22 12H26M14 18H18M22 18H26M14 24H18M22 24H26M16 34V30H24V34'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    briefcase: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'12'}
                width={'32'}
                height={'22'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 12V8C14 6 16 4 18 4H22C24 4 26 6 26 8V12M4 22H36'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    phone: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'10'}
                y={'4'}
                width={'20'}
                height={'32'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M10 28H30M10 10H30'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'20'}
                cy={'32'}
                r={'1'}
                fill={'white'}
            />
        </svg>
    ),

    mail: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'8'}
                width={'32'}
                height={'24'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M4 12L20 22L36 12'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    bell: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M12 16C12 12 16 6 20 6C24 6 28 12 28 16V26H12V16Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M8 26H32M16 30C16 32 18 34 20 34C22 34 24 32 24 30'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    'search-alt': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'18'}
                cy={'18'}
                r={'10'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M26 26L34 34'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    settings: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={
                    'M18 6H22L23 10L27 12L30 9L33 12L30 16L32 20V22L36 23V27L32 28L30 32L33 35L30 38L26 35L22 37H18L17 33L13 31L10 34L7 31L10 27L8 23V21L4 20V16L8 15L10 11L7 8L10 5L14 8L18 6Z'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    share: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'30'}
                cy={'10'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'10'}
                cy={'20'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'30'}
                cy={'30'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 18L26 12M14 22L26 28'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    download: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4V26M20 26L12 18M20 26L28 18M6 30V34H34V30'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    'upload-alt': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 26V4M20 4L12 12M20 4L28 12M6 30V34H34V30'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    folder: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 10H16L20 6H36V34H4V10Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    file: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 4H24L32 12V36H8V4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M24 4V12H32'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    clipboard: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'8'}
                y={'6'}
                width={'24'}
                height={'30'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 6V4C14 2 16 2 20 2C24 2 26 2 26 4V6M14 16H26M14 22H26M14 28H20'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    bookmark: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 4H32V36L20 28L8 36V4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    tag: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 4H20L36 20L20 36L4 20V4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <circle
                cx={'12'}
                cy={'12'}
                r={'2'}
                fill={'white'}
            />
        </svg>
    ),

    link: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M16 24L24 16M14 20L10 24C8 26 8 30 10 32L8 30C10 32 14 32 16 30L20 26M20 14L24 10C26 8 30 8 32 10L30 8C32 10 32 14 30 16L26 20'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    map: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 8L14 4V32L4 36V8ZM14 4L26 8V36L14 32V4ZM26 8L36 4V32L26 36V8Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    pin: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4C14 4 8 10 8 16C8 24 20 36 20 36C20 36 32 24 32 16C32 10 26 4 20 4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'16'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    layers: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L36 14L20 24L4 14L20 4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M4 20L20 30L36 20M4 26L20 36L36 26'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    grid: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'6'}
                width={'10'}
                height={'10'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <rect
                x={'24'}
                y={'6'}
                width={'10'}
                height={'10'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <rect
                x={'6'}
                y={'24'}
                width={'10'}
                height={'10'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <rect
                x={'24'}
                y={'24'}
                width={'10'}
                height={'10'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    cpu: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'10'}
                y={'10'}
                width={'20'}
                height={'20'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <rect
                x={'14'}
                y={'14'}
                width={'12'}
                height={'12'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M16 6V10M24 6V10M16 30V34M24 30V34M6 16H10M6 24H10M30 16H34M30 24H34'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    database: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <ellipse
                cx={'20'}
                cy={'10'}
                rx={'14'}
                ry={'6'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M6 10V30C6 33 12 36 20 36C28 36 34 33 34 30V10'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M6 20C6 23 12 26 20 26C28 26 34 23 34 20'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    'shield-check': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 3L6 9V19C6 27 12 33 20 37C28 33 34 27 34 19V9L20 3Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M13 20L18 25L27 16'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    alert: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4L36 34H4L20 4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M20 16V22M20 28V28.5'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    'check-circle': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'16'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M12 20L18 26L28 14'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    'x-circle': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'16'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 14L26 26M26 14L14 26'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    info: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'16'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M20 18V28M20 12V12.5'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    help: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'16'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 14C14 10 17 8 20 8C23 8 26 10 26 14C26 18 20 18 20 24M20 30V30.5'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    zap: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M22 4L8 22H20L18 36L32 18H20L22 4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    trending: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 28L14 18L22 26L36 12M36 12H26M36 12V22'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    'pie-chart': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'14'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M20 6V20L30 28'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    'bar-chart': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 34H34M10 28V16M18 28V10M26 28V20M34 28V14'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    'line-chart': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 32L12 24L20 28L28 16L36 8'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />

            <circle
                cx={'12'}
                cy={'24'}
                r={'2'}
                fill={'white'}
            />

            <circle
                cx={'20'}
                cy={'28'}
                r={'2'}
                fill={'white'}
            />

            <circle
                cx={'28'}
                cy={'16'}
                r={'2'}
                fill={'white'}
            />
        </svg>
    ),

    activity: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 20H10L14 8L20 32L26 14L30 20H36'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    heartbeat: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 20H12L16 12L20 28L24 16L28 20H36'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    pill: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M10 10L30 30M10 10C6 14 6 20 10 24L16 30C20 34 26 34 30 30C34 26 34 20 30 16L24 10C20 6 14 6 10 10Z'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                fill={'none'}
            />
        </svg>
    ),

    stethoscope: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M10 4V16C10 22 14 26 20 26C26 26 30 22 30 16V4'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />

            <circle
                cx={'20'}
                cy={'32'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M20 28V26'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    'sun-rise': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M4 28H36M8 28C8 22 14 16 20 16C26 16 32 22 32 28M20 4V10M6 14L10 18M34 14L30 18'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    'moon-stars': (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M28 8C20 10 14 18 14 26C14 30 16 34 20 36C12 36 6 30 6 22C6 14 12 8 20 8C23 8 26 8 28 8Z'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={
                    'M30 6L31 9L34 10L31 11L30 14L29 11L26 10L29 9L30 6ZM36 16L37 18L39 19L37 20L36 22L35 20L33 19L35 18L36 16Z'
                }
                stroke={'white'}
                strokeWidth={'2'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    wind: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 14H26C30 14 32 10 28 8M4 20H32C36 20 38 24 34 26M4 26H22C26 26 28 30 24 32'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    snowflake: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 4V36M4 20H36M8 8L32 32M32 8L8 32M14 7L20 12L26 7M14 33L20 28L26 33M7 14L12 20L7 26M33 14L28 20L33 26'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    thermometer: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M16 24V8C16 6 18 4 20 4C22 4 24 6 24 8V24C28 26 28 32 24 34C20 36 16 34 14 30C12 26 14 24 16 24Z'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                fill={'none'}
            />

            <circle
                cx={'20'}
                cy={'28'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    droplet: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 4C20 4 8 16 8 24C8 32 14 36 20 36C26 36 32 32 32 24C32 16 20 4 20 4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    flame: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 4C20 4 10 14 10 24C10 30 14 36 20 36C26 36 30 30 30 24C30 14 20 4 20 4ZM20 16C20 16 14 22 14 26C14 30 17 32 20 32C23 32 26 30 26 26C26 22 20 16 20 16Z'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    seedling: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 36V20M20 20C20 14 14 10 8 10C8 18 14 22 20 20ZM20 20C20 14 26 10 32 10C32 18 26 22 20 20Z'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    fruit: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'24'}
                r={'10'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M20 14V8M16 8C16 6 18 4 20 4C22 4 24 6 24 8'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    wheat: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 36V20M20 20C14 16 12 10 14 4M20 20C26 16 28 10 26 4M20 20C12 18 8 14 8 8M20 20C28 18 32 14 32 8'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    eco: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 32C8 32 8 16 20 8C32 8 32 24 32 24C32 30 26 36 20 36C14 36 8 32 8 32Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M12 28C12 28 16 24 20 20C24 16 28 12 28 12'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    planet: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'20'}
                r={'12'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <ellipse
                cx={'20'}
                cy={'20'}
                rx={'18'}
                ry={'6'}
                stroke={'white'}
                strokeWidth={'2.5'}
                transform={'rotate(-20 20 20)'}
            />
        </svg>
    ),

    satellite: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'14'}
                y={'14'}
                width={'12'}
                height={'12'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
                transform={'rotate(45 20 20)'}
            />

            <path
                d={'M8 8L14 14M26 26L32 32M8 32L14 26M26 14L32 8'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    antenna: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M20 16V36M12 36H28M20 16L10 6M20 16L30 6'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />

            <circle
                cx={'20'}
                cy={'16'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    radio: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'12'}
                width={'32'}
                height={'22'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'14'}
                cy={'24'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M22 20H32M22 24H32M22 28H28M4 12L24 4'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    tv: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'8'}
                width={'32'}
                height={'22'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M12 34H28M20 30V34'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    monitor: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'6'}
                width={'32'}
                height={'22'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 34H26M20 28V34'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    laptop: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'8'}
                width={'28'}
                height={'18'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M2 30H38L36 34H4L2 30Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    tablet: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'8'}
                y={'4'}
                width={'24'}
                height={'32'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'20'}
                cy={'32'}
                r={'1'}
                fill={'white'}
            />
        </svg>
    ),

    watch: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'10'}
                y={'8'}
                width={'20'}
                height={'24'}
                rx={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 8V4H26V8M14 32V36H26V32M20 14V20L24 22'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    headphones: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M8 20V28C8 30 6 32 6 32V24M32 20V28C32 30 34 32 34 32V24'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />

            <path
                d={'M8 20C8 14 14 8 20 8C26 8 32 14 32 20'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <rect
                x={'4'}
                y={'22'}
                width={'6'}
                height={'10'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <rect
                x={'30'}
                y={'22'}
                width={'6'}
                height={'10'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    mic: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'14'}
                y={'4'}
                width={'12'}
                height={'20'}
                rx={'6'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M8 18C8 26 14 30 20 30C26 30 32 26 32 18M20 30V36M14 36H26'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    speaker: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'8'}
                y={'6'}
                width={'16'}
                height={'28'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'16'}
                cy={'24'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'16'}
                cy={'12'}
                r={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    volume: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 14H12L22 6V34L12 26H6V14Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M28 14C30 16 30 24 28 26M32 10C36 14 36 26 32 30'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    play: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M10 6V34L34 20L10 6Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    pause: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'8'}
                y={'6'}
                width={'8'}
                height={'28'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <rect
                x={'24'}
                y={'6'}
                width={'8'}
                height={'28'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    stop: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'8'}
                y={'8'}
                width={'24'}
                height={'24'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    forward: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 8V32L20 20L4 8ZM20 8V32L36 20L20 8Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    rewind: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M36 8V32L20 20L36 8ZM20 8V32L4 20L20 8Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    repeat: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M8 20C8 14 14 8 20 8H28M28 8L24 4M28 8L24 12M32 20C32 26 26 32 20 32H12M12 32L16 36M12 32L16 28'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    shuffle: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M4 10H12L28 30H36M36 30L32 26M36 30L32 34M4 30H12L16 24M24 16L28 10H36M36 10L32 6M36 10L32 14'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    maximize: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M4 14V4H14M26 4H36V14M36 26V36H26M14 36H4V26M4 4L14 14M36 4L26 14M36 36L26 26M4 36L14 26'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    minimize: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M14 4V14H4M26 14H36V4M36 26H26V36M4 26V36H14M14 14L4 4M26 14L36 4M26 26L36 36M14 26L4 36'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    crop: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M10 4V30H36M4 10H30V36'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    rotate: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M32 20C32 26 26 32 20 32C14 32 8 26 8 20C8 14 14 8 20 8H28M28 8L24 4M28 8L24 12'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    flip: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 8H16V32H4V8ZM24 8H36V32H24V8ZM20 4V36'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    filter: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 8H36L24 22V32L16 36V22L4 8Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    sliders: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M12 4V14M12 22V36M20 4V26M20 34V36M28 4V10M28 18V36M8 18H16M16 30H24M24 14H32'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    toggle: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'4'}
                y={'12'}
                width={'32'}
                height={'16'}
                rx={'8'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'28'}
                cy={'20'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    power: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={
                    'M20 4V20M10 10C6 14 4 20 6 26C8 32 14 36 20 36C26 36 32 32 34 26C36 20 34 14 30 10'
                }
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    bolt: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M22 4L8 22H20L18 36L32 18H20L22 4Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />
        </svg>
    ),

    plug: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M14 4V12M26 4V12M10 12H30V18C30 26 26 30 20 30C14 30 10 26 10 18V12ZM20 30V36'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    outlet: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'6'}
                width={'28'}
                height={'28'}
                rx={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M14 14V18M26 14V18M16 26C16 24 18 22 20 22C22 22 24 24 24 26'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    solar: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'6'}
                y={'14'}
                width={'28'}
                height={'20'}
                rx={'2'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M6 22H34M6 30H34M14 14V34M26 14V34M20 4V10M30 8L26 12M10 8L14 12'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    windmill: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'20'}
                cy={'14'}
                r={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M20 18V36M14 36H26M20 10V4M10 14H4M30 14H36M14 8L10 4M26 8L30 4'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    factory: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 36H36V20L28 26V20L20 26V20L12 26V14H4V36Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M8 8V14M8 4V6'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    warehouse: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 16L20 6L36 16V36H4V16Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M14 36V24H26V36M4 22H36'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    truck: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 10H24V28H4V10ZM24 16H32L36 22V28H24V16Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <circle
                cx={'12'}
                cy={'30'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'30'}
                cy={'30'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    ship: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M4 28L8 20H32L36 28C32 32 28 32 24 30C20 32 16 32 12 30C8 32 4 32 4 28Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <path
                d={'M12 20V12H20V6L28 12V20'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),

    train: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <rect
                x={'8'}
                y={'4'}
                width={'24'}
                height={'26'}
                rx={'4'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M8 18H32M14 36L10 30H30L26 36M12 24H14M26 24H28'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
            />
        </svg>
    ),

    car: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M6 20L10 12H30L34 20V26H6V20Z'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinejoin={'round'}
                fill={'none'}
            />

            <circle
                cx={'12'}
                cy={'28'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'28'}
                cy={'28'}
                r={'3'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M6 20H34'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />
        </svg>
    ),

    bicycle: (s: number) => (
        <svg
            width={s}
            height={s}
            viewBox={'0 0 40 40'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <circle
                cx={'10'}
                cy={'26'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <circle
                cx={'30'}
                cy={'26'}
                r={'6'}
                stroke={'white'}
                strokeWidth={'2.5'}
            />

            <path
                d={'M10 26L16 14H24L30 26M16 14L20 8H26'}
                stroke={'white'}
                strokeWidth={'2.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    ),
};

export const getIconSvg = (iconId: string, size: number = 40): React.ReactElement =>
    (iconSvgs[iconId] ?? iconSvgs.heart)(size);
